import React from 'react';
import { Users, ShoppingCart, Book, IndianRupee} from 'lucide-react';


export default function OverviewCard({ title, value, icon,titleColor, valueColor }) {
  const Icon = {
    users: Users,
    'rupee-sign': IndianRupee,
    'shopping-cart': ShoppingCart,
    'course':Book,
  }[icon];

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className={`text-sm font-medium text-gray-500 ${titleColor}`}>{title}</h2>
          <p className={`text-3xl font-semibold text-gray-800 ${valueColor}`}>{value}</p>
        </div>
        <Icon className="text-blue-500" size={32} />
      </div>
    </div>
  );
}